import { styled } from 'styled-components';

export const CmsImageBlockImageOrFigureHolder = styled.div`
  margin: 0;
`;
